// ...existing code...
<template>
  <div class="container py-4">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6">
        <div class="card shadow-sm">
          <div class="card-body">
            <h3 class="card-title mb-3">Restablecer contraseña</h3>

            <form @submit.prevent="submit" novalidate>
              <input type="hidden" v-model="form.token" />

              <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input
                  id="email"
                  v-model="form.email"
                  type="email"
                  required
                  class="form-control"
                  placeholder="tu@correo.com"
                />
              </div>

              <div class="mb-3">
                <label for="password" class="form-label">Nueva contraseña</label>
                <input
                  id="password"
                  v-model="form.password"
                  type="password"
                  required
                  minlength="8"
                  class="form-control"
                  placeholder="Mínimo 8 caracteres"
                />
                <div v-if="form.password && form.password.length < 8" class="form-text text-danger">
                  La contraseña debe tener al menos 8 caracteres.
                </div>
              </div>

              <div class="mb-3">
                <label for="password_confirmation" class="form-label">Confirmar contraseña</label>
                <input
                  id="password_confirmation"
                  v-model="form.password_confirmation"
                  type="password"
                  required
                  minlength="8"
                  class="form-control"
                  placeholder="Repite la contraseña"
                />
                <div v-if="form.password_confirmation && form.password !== form.password_confirmation" class="form-text text-danger">
                  Las contraseñas no coinciden.
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <button
                  class="btn btn-primary"
                  :disabled="loading || !canSubmit"
                  type="submit"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ loading ? 'Procesando...' : 'Restablecer' }}
                </button>
              </div>

              <div class="mt-3">
                <div v-if="message" :class="['alert', error ? 'alert-danger' : 'alert-success']" role="alert">
                  {{ message }}
                </div>
              </div>
            </form>

            <div class="mt-3 text-center">
              <router-link to="/" class="link-secondary">Volver a iniciar sesión</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ResetPassword',
  data() {
    return {
      form: {
        token: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      loading: false,
      message: null,
      error: false
    }
  },
  computed: {
    canSubmit() {
      return (
        this.form.email &&
        this.form.password &&
        this.form.password_confirmation &&
        this.form.password.length >= 8 &&
        this.form.password === this.form.password_confirmation
      )
    }
  },
  created() {
    if (this.$route && this.$route.query) {
      this.form.token = this.$route.query.token || ''
      this.form.email = this.$route.query.email || ''
    } else {
      const qp = Object.fromEntries(new URLSearchParams(window.location.search))
      this.form.token = qp.token || ''
      this.form.email = qp.email || ''
    }
  },
  methods: {
    async submit() {
      this.loading = true
      this.message = null
      this.error = false
      try {
        const payload = {
          token: this.form.token,
          email: this.form.email,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation
        }
        const res = await axios.post('/api/password/reset', payload)
        this.message = res.data.message || 'Contraseña restablecida. Inicia sesión.'
        // redirigir al login después de 1.5s
        setTimeout(() => { this.$router && this.$router.push({ name: 'Sign-In' }); }, 1500)
      } catch (err) {
        this.error = true
        this.message =
          (err.response && (err.response.data.message || (err.response.data.errors && Object.values(err.response.data.errors).flat().join(', ')))) ||
          'Error al restablecer'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.reset-password { min-height: 220px; }
.card { border-radius: 0.75rem; }
.card-title { font-weight: 600; }
.form-text.text-danger { font-size: 0.9rem; }
@media (max-width: 576px) {
  .card { margin: 0 0.5rem; }
}
</style>
// ...existing code...